import styled from 'styled-components';

export const RankContainerStyles = styled.div`
	border: ${(props) => `1px solid ${props.theme.v3.colors.gray[4]}`};
	border-radius: 0.25rem;

	&.placeholder {
		border-style: dashed;
		background: ${(props) => `${props.theme.v3.colors.white[0]}`};
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

		.rank-header {
			border-style: dashed;
		}
	}

	.rank-header {
		min-height: 3rem;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		border-bottom: ${(props) => `1px solid ${props.theme.v3.colors.gray[4]}`};
	}

	.sort-actions {
		display: flex;
		flex-direction: column;
		border-right: ${(props) => `1px solid ${props.theme.v3.colors.gray[4]}`};

		button {
			flex: 1;
			border: 0;
			background: none;
		}

		&.disabled {
			button {
				opacity: 0.5;
				pointer-events: none;
			}
		}
	}

	.rank-info {
		display: flex;
		gap: 0.5rem;
		align-items: center;
		margin-left: 0.5rem;
	}

	.rank-type-pill {
		margin: 0 0.5rem 0 auto;

		~ .rank-dropdown {
			margin-left: 0;
		}
	}

	.rank-dropdown {
		margin: auto 0.5rem auto auto;
	}

	.name-input {
		border: 1px solid ${(props) => props.theme.v3.colors.gray[4]};
		border-radius: 0.25rem;
		padding: 0.25rem;
	}

	.sort-number {
		border-radius: 1rem;
		padding: 0.25rem 0.375rem;
		background: ${(props) => props.theme.v3.colors.gray[4]};
	}

	.caret {
		padding: 0.25rem;
		color: ${(props) => props.theme.v3.colors.gray[4]};
		transition:
			background 0.2s ease-in-out,
			color 0.2s ease-in-out;

		&:hover {
			color: ${(props) => props.theme.v3.colors.dark[4]};
			background: ${(props) => props.theme.v3.colors.gray[4]};
		}
	}

	.rank-content {
		position: relative;
		padding: 0.5rem;
	}

	.empty {
		max-width: 452px;
		margin: 2.25rem auto;
		text-align: center;
	}

	.remove-container {
		position: relative;
		z-index: 5;
		margin-top: 0.5rem;
		text-align: center;

		.remove-button {
			margin-bottom: 0;
		}
	}

	.securities-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
		gap: 0.5rem;
	}

	.placeholder {
		padding: 1.375rem 0;
		text-align: center;
	}

	.unsupported-overlay {
		position: absolute;
		inset: 0;
		z-index: 5;
		display: grid;
		place-items: center;
		padding: 1rem;

		&:before {
			content: '';
			position: absolute;
			inset: 0;
			background: ${(props) => props.theme.v3.colors.gray[0]};
			opacity: 0.8;
		}
	}

	.unsupported-message {
		position: relative;
	}
`;
